import types from "./types";
import voa_summary_service from "./service";

const getVoaSummary = () => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_VOA_SUMMARY });
        voa_summary_service
            .getVoaSummary(getState().voa_summary.pagination.actualPage, getState().voa_summary.filters)
            .then(result => {
                dispatch(getAllSuccess(result.list));
                dispatch(updatePagination(result.pagination));
            })
            .catch(err => dispatch(getAllFail(err)));
    };
};

const updateFilter = filters => {
    return dispatch => {
        dispatch(changeFilters(filters));
        dispatch(changeVoaSummaryPage({ page: 1 }));
        dispatch(getVoaSummary());
    };
};

const changePage = page => {
    return dispatch => {
        dispatch(changeVoaSummaryPage({ page: page }));
        dispatch(getVoaSummary());
    };
};

const getAllSuccess = payload => ({
    type: types.GET_VOA_SUMMARY_SUCCESS,
    payload
});

const getAllFail = error => ({
    type: types.GET_VOA_SUMMARY_FAIL,
    payload: error
});

const updatePagination = payload => ({
    type: types.UPDATE_SUMMARY_PAGINATION,
    payload
});

const changeFilters = payload => ({
    type: types.FILTER_LIST_SUMMARY,
    payload
});

const changeVoaSummaryPage = payload => ({
    type: types.CHANGE_PAGE_SUMMARY,
    payload
});

export default {
    getVoaSummary,
    updateFilter,
    changePage
};
